import { useEffect, useState } from "react";

const TZ = "America/New_York";
const LAST_EVENT_MIN = 90;
const NOT_LIVE = new Set(["Canceled", "Completed", "Delayed"]);

export const toMinutes = (t) => {
  const s = (t || "").trim().toLowerCase();
  if (s.startsWith("noon")) return 720;
  const m = s.match(/^(\d{1,2})(?::(\d{2}))?\s*([ap])?/);
  if (!m) return null;
  let h = Number(m[1]) % 24;
  const mi = Number(m[2] || 0);
  if (m[3] === "p" && h < 12) h += 12;
  if (m[3] === "a" && h === 12) h = 0;
  return h * 60 + mi;
};

// Event-local (Kentucky) date + minutes. `?now=2026-10-30T13:45` overrides for previewing show day.
const eventClock = () => {
  const o = new URLSearchParams(window.location.search).get("now");
  if (o && /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}/.test(o)) {
    return { date: o.slice(0, 10), min: Number(o.slice(11, 13)) * 60 + Number(o.slice(14, 16)) };
  }
  const p = Object.fromEntries(new Intl.DateTimeFormat("en-CA", { timeZone: TZ, year: "numeric", month: "2-digit", day: "2-digit", hour: "2-digit", minute: "2-digit", hourCycle: "h23" })
    .formatToParts(new Date()).map((x) => [x.type, x.value]));
  return { date: `${p.year}-${p.month}-${p.day}`, min: Number(p.hour) * 60 + Number(p.minute) };
};

export const useEventClock = () => {
  const [clock, setClock] = useState(eventClock);
  useEffect(() => {
    const id = setInterval(() => setClock(eventClock()), 60000);
    return () => clearInterval(id);
  }, []);
  return clock;
};

// Admin "Happening Now" status wins; otherwise the event whose time slot contains now.
export const findLive = (items, clock) => {
  const manual = items.find((s) => s.status === "Happening Now");
  if (manual) return manual;
  const today = items.filter((s) => s.date === clock.date && !NOT_LIVE.has(s.status) && toMinutes(s.start_time) !== null);
  for (let i = 0; i < today.length; i += 1) {
    const start = toMinutes(today[i].start_time);
    const end = i + 1 < today.length ? toMinutes(today[i + 1].start_time) : start + LAST_EVENT_MIN;
    if (clock.min >= start && clock.min < end) return today[i];
  }
  return null;
};

export const findNext = (items, clock) => items.find((s) => !NOT_LIVE.has(s.status) &&
  (s.date > clock.date || (s.date === clock.date && (toMinutes(s.start_time) ?? -1) > clock.min)));
